import ChartApi from '../../../pages/instituciones/instituciones-v2/ChartApi';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApi piePagina={'*Años 2015 a 2021 corresponden a promedios anuales.'} />
          </div>
        </div>
      </div>
    </div>
  )
}

